import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router';
import { loadConversationSettings, useLearningLanguage } from '@/entities/user';
import { ROUTES } from '@/shared/config';
import { TabBar } from '@/widgets/main-tabs';
import { preloadPagesWhenIdle, preloadProfileSubpages } from './lazyPages';

/**
 * Общий каркас экранов с нижними табами: страница + фиксированная панель поверх неё.
 *
 * Страница перемонтируется на каждую смену изучаемого языка (`generation`):
 * переключатель стоит в шапке главной, и после выбора всё на экране —
 * практика, история, статистика — должно перечитаться под новый язык. Экраны
 * вне табов перемонтировать незачем: на них из главной переходят уже после
 * смены, и они и так грузятся заново.
 *
 * Отсюда же после первого рендера стартует предзагрузка остальных страниц:
 * каркас табов — первый настоящий экран после `/me`, раньше сеть занята им.
 */
export function MainLayout() {
  const { generation } = useLearningLanguage();
  const { pathname } = useLocation();
  useEffect(preloadPagesWhenIdle, []);
  useEffect(() => {
    if (pathname !== ROUTES.profile) return;
    preloadProfileSubpages();
    // Данные «Персонализации» — туда же: страница не должна начинать их
    // грузить только после перехода. Ошибку глотаем: страница перезапросит сама.
    loadConversationSettings().catch(() => undefined);
  }, [pathname]);
  return (
    <>
      <Outlet key={generation} />
      <TabBar />
    </>
  );
}
